import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Slides from '@ifeng/ui_pc_slides';

class PhtvSlide extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    sliderTmpl = item => {
        return (
            <div className={styles.big_pic}>
                <a href={item.url} className={styles.pic_img} target="_blank" data-nomask>
                    <img src={item.thumbnail} className={styles.trans} />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} target="_blank" data-innermask>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    render() {
        const { content } = this.props;
        const config = {
            dots: true,
            dotsAction: 'hover',
            autoplayInterval: 3000,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={`${styles.slide_box}`}>
                <Slides content={content} config={config} />
            </div>
        );
    }
}

export default errorBoundary(PhtvSlide);
